import styled from 'styled-components';

export const StyledModalExit = styled.button`
  background-color: transparent;
  border: none;
  width: 100%;
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[6]};
  box-shadow: ${(p) => p.theme.shadows.bottom};
  // prettier-ignore
  border-radius:
    ${(p) => p.theme.space[3]}
    ${(p) => p.theme.space[3]}
    ${(p) => p.theme.space[0]}
    ${(p) => p.theme.space[0]};
  text-align: left;

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled):hover {
    background-color: ${(p) => p.theme.alias.shadow};
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusInner};
  }
`;
